import { createSlice } from '@reduxjs/toolkit';
import { rolPermission } from 'src/models/rol';

import { User } from 'src/models/user';
import { Producer } from 'src/models/producer';
import { rolesApp } from 'src/utils/rolesConstants';

interface AuthState {
  isLoading: boolean;
  profile: User;
  isErrorMessage: string;
  statusCode: number;
  error: null;
  roles: rolPermission[];
  isAuth: boolean;
  isMultiproducer: boolean;
  producers: Producer[];
  selectedProducer: Producer | null | undefined;
}

const initialState: AuthState = {
  isLoading: false,
  statusCode: 201,
  isErrorMessage: '',
  profile: null,
  roles: null,
  error: null,
  isAuth: false,
  isMultiproducer: false,
  producers: [],
  selectedProducer: undefined
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    setUserAuth: (state, action) => {
      state.profile = action.payload.user;
      state.roles = action.payload.roles;
      state.isAuth = true;
    },
    setError: (state, action) => {
      const message = action.payload.message;
      state.statusCode = action.payload.statusCode;
      state.isErrorMessage = message;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setProducersSettings: (state, action) => {
      state.isMultiproducer = action.payload.isMultiproducer;
      //Roles con funcionalidad en el BO
      const rolesPermissions = [rolesApp.SUPERADMIN, rolesApp.ADMIN, rolesApp.PRODUCTOR, rolesApp.POS];
      //Filtralmos los roles que tengan funcionalidades dentro del BO
      const validRoles = state.profile?.proRoles?.filter((role) => rolesPermissions.includes(role.id));
      //filtramos las productoras que tengan por lo menos un rol con permisos en el BO
      if (action.payload.producers !== undefined) {
      const producersValid = action.payload.producers.filter((producer) => validRoles.some((role) => role.producerId?.some((producerId) => producerId?.id?.toString() === producer?.id?.toString())));
      state.producers = producersValid;
      }
    },
    setSelectedProducer: (state, action) => {
      state.selectedProducer = action.payload;
      if (action.payload) {
        sessionStorage.setItem(
          'selectedProducer',
          JSON.stringify(action.payload)
        );
      } else {
        sessionStorage.removeItem('selectedProducer');
      }
    },
    clearAuthState: (state) => {
      state.isAuth = false;
      state.profile = null;
      state.roles = null;
      state.isMultiproducer = false;
      state.producers = [];
      state.selectedProducer = undefined;
      sessionStorage.removeItem('selectedProducer');
      sessionStorage.removeItem('producersConfig');
    }
  }
});

export const {
  startLoading,
  stopLoading,
  setUserAuth,
  setError,
  setProducersSettings,
  setSelectedProducer,
  clearAuthState
} = authSlice.actions;
